// extracted by mini-css-extract-plugin
export default {"container":"NumberIcon_container__WL0Zk","number":"NumberIcon_number__aN9mB","offsetLeft":"NumberIcon_offsetLeft__69oMp"};